export enum NotificationSubpage {
    Announcements,
    NotificationsForStudent,
}
